import React , {Component} from 'react'
import MainLayout from "../../components/layouts/mainLayout";

export default class CryptoCurrencyNews extends Component {
    render(){
        return(
            <MainLayout>
            <div className={"newsWrapper"}>
                <div className="container">
                    <div className="news">
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                        <h1>lskdsdlk</h1>
                    </div>
                </div>
            </div>
            </MainLayout>
        )
    }
}